import { Tier } from '@mondaygpt/constants'

/** At or below this balance (and > 0) credits are treated as "low": the one-time
 *  low-credit analytics event fires. Lives here (not inline in `CreditPusherHandler`)
 *  so any future low-credit surface shares the same threshold. */
export const CREDITS_LOW_THRESHOLD = 10

export interface PlanFeatureConfig {
  credits: number
  seats: number
  features: string[]
}

const FEATURE_ALL_CREATIVE_TYPES = 'All creative types (image, carousel, video)'

/** Zero-credits system messaging — shared across banner, composer, and billing. */
export const CREDITS_ADD_CTA = 'Add credits'
export const CREDITS_EXHAUSTED_TITLE = 'All credits used'
export const CREDITS_EXHAUSTED_SUBTITLE = 'Add credits to keep generating posts.'
export const CREDITS_EXHAUSTED_BILLING_DETAIL = 'Each AI generation uses 1 credit.'
// The top-up bucket holds purchased packs AND the annual-plan bonus — label
// it by its behavior (never expires), not by how the credits got there.
export const CREDITS_PURCHASED_POOL_LABEL = 'Extra credits'

// `features` holds only the rows NOT derivable from the numeric fields —
// surfaces that want credits/seats as display rows use formatPlanRows.
export const PLAN_FEATURES: Record<string, PlanFeatureConfig> = {
  [Tier.Pro]: {
    credits: 100,
    seats: 2,
    features: ['Unlimited post scheduling', FEATURE_ALL_CREATIVE_TYPES, 'Standard support'],
  },
  [Tier.Business]: {
    credits: 300,
    seats: 10,
    features: ['Unlimited post scheduling', FEATURE_ALL_CREATIVE_TYPES, 'Priority support'],
  },
}

/** Full display row list for a plan, credits/seats composed from the numeric
    fields so plan facts can't drift between surfaces. */
export const formatPlanRows = (config: PlanFeatureConfig): string[] => [
  `${config.credits} AI generation credits / month`,
  `${config.seats} team seats`,
  ...config.features,
]
